module.exports = __webpack_public_path__ + "media/video2.ed865498.mp4";